import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import PageNotFound from "../PageNotFound/PageNotFound";
import routes from "../../constants/routes";
import { resolveRegionId } from "../../constants/regionConfig";

const OrderQueryRedirect = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");
  const regionId = resolveRegionId(searchParams.get("region_id"));

  if (!orderId) {
    return <PageNotFound />;
  }

  return (
    <Navigate
      to={`${routes.orderPayments}/${orderId}?region_id=${regionId}`}
      replace
    />
  );
};

export default OrderQueryRedirect;
